import { useState } from 'react';

export const useFormHandler = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (submitFn, onSuccess = null, onError = null) => {
        if (isSubmitting) return; // Previne múltiplos submits

        setIsSubmitting(true);
        try {
            const result = await submitFn();
            onSuccess?.(result);
        } catch (error) {
            onError?.(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return { isSubmitting, handleSubmit };
};